<div class="modal--generic">
  <h1 class="modal__header">{{ data.title }}</h1>
  <div class="modal__body" [innerHtml]="data.body | safeHtml"></div>
  <div *ngIf="data.actions" class="modal__actions modal__actions--inline">
    <button *ngIf="data.actions.confirm" class="button button--blue button--primary modal__button" (click)="confirm()">
      {{ data.actions.confirm.text }}
    </button>
    <button
      *ngIf="data.actions.cancel"
      class="button button--blue button--secondary button--no-border modal__button"
      (click)="cancel()"
    >
      {{ data.actions.cancel.text }}
    </button>
  </div>
</div>
